<script setup lang="ts">
const props = defineProps<{ modelValue: boolean; disabled?: boolean }>()
const emit = defineEmits<{
  (emit: 'update:modelValue', value: boolean): void
}>()

const proxyModelValue = computed({
  get() {
    return props.modelValue
  },
  set(value: boolean) {
    emit('update:modelValue', value)
  }
})
</script>

<template>
  <label class="switch">
    <input v-model="proxyModelValue" :disabled="disabled" type="checkbox" />
    <span class="slider"></span>
  </label>
</template>

<style scoped lang="scss">
.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 3rem;
  min-width: 3rem;
  height: 1.5rem;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background: $ui-gray-2;
  border-radius: 30px;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.slider:before {
  position: absolute;
  content: '';
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  width: 1.5rem;
  inset: 0;
  background-color: white;
  border-radius: 50px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.switch input:checked + .slider {
  background: $sub-green;
}

.switch input:checked + .slider:before {
  transform: translateX(1.5rem);
  background-color: $primary-green;
}
</style>
